<template>
  <div>
    <div class="page-title mb-30">Firmware & Software</div>
    <div class="page-content" v-loading="loading">
      <div class="firmware-card">
        <div class="firmware-card__hdr">
          <span>Production</span>
          <el-button
            size="mini"
            type="primary"
            @click="uploadNew()"
            v-if="p('Production.Firmware & Software.Upload')"
            >UPLOAD NEW PRODUCTION FW</el-button
          >
        </div>
        <el-table border size="small" :data="data" max-height="320">
          <el-table-column label="Software" prop="software"></el-table-column>
          <el-table-column label="Environment">
            <template slot-scope="scope">
              <div v-if="scope.row.isProduction">
                {{ environments.production }}
              </div>
              <div v-if="scope.row.isStaging">{{ environments.staging }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Type" prop="type"></el-table-column>
          <el-table-column
            label="Version"
            prop="fwVersion"
            width="100px"
          ></el-table-column>
          <el-table-column label="Uploaded" prop="uploadedDate">
            <template slot-scope="scope">
              {{ moment(scope.row.uploadedDate).format('DD/MM/YYYY @ hh:mma') }}
            </template>
          </el-table-column>
          <el-table-column
            label="Uploaded By"
            prop="userName"
          ></el-table-column>
        </el-table>
      </div>
      <div class="firmware-card">
        <div class="firmware-card__hdr">
          <span>Release History</span>
        </div>
        <el-table border size="small" :data="releaseHistory" max-height="400">
          <el-table-column
            label="Software"
            prop="software"
            fixed="left"
          ></el-table-column>
          <el-table-column label="Environment">
            <template slot-scope="scope">
              <div v-if="scope.row.isProduction">
                {{ environments.production }}
              </div>
              <div v-if="scope.row.isStaging">{{ environments.staging }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Type" prop="type"></el-table-column>
          <el-table-column
            label="Version"
            prop="fwVersion"
            width="100px"
          ></el-table-column>
          <el-table-column label="Uploaded" prop="uploadedDate">
            <template slot-scope="scope">
              {{ moment(scope.row.uploadedDate).format('DD/MM/YYYY @ hh:mma') }}
            </template>
          </el-table-column>
          <el-table-column
            label="Uploaded By"
            prop="userName"
          ></el-table-column>
          <el-table-column
            label="Action"
            fixed="right"
            width="360"
            v-if="p('Production.Firmware & Software.Upload')"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                plain
                @click="moveToProd(scope.row.id)"
                >MOVE TO PRODUCTION</el-button
              >
              <el-button
                v-if="!scope.row.isStaging"
                type="primary"
                size="mini"
                plain
                @click="moveToStage(scope.row.id)"
                >MOVE TO STAGING</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <UploadNewProductionFw ref="uploadNewProductionFw" />
    </div>
  </div>
</template>

<script>
import UploadNewProductionFw from '@/components/production/pod/UploadNewProductionFw'
import moment from 'moment'
import swal from 'sweetalert'
import ApiService from '@/services/CommonApiService.js'
import { environments } from '../../../const'
export default {
  data() {
    return {
      environments,
      moment,
      loading: false,
      data: [],
      releaseHistory: []
    }
  },
  components: {
    UploadNewProductionFw
  },
  mounted() {
    this.getData()
  },
  methods: {
    uploadNew() {
      this.$refs.uploadNewProductionFw.openDialog()
    },
    getData() {
      this.loading = true
      ApiService.GetFirmwares()
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.data = response.data.data.filter(item => {
              return item.isProduction
            })
            this.releaseHistory = response.data.data.filter(item => {
              return !item.isProduction
            })
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    moveToProd(id) {
      ApiService.MoveToProd(id)
        .then(response => {
          if (response.data.success) {
            this.getData()
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    moveToStage(id) {
      ApiService.MovetoStage(id)
        .then(response => {
          if (response.data.success) {
            this.getData()
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.firmware-card {
  background: #ffffff;
  border: 1px solid #e2e5ec;
  border-radius: 10px;
  margin-bottom: 20px;
  overflow: hidden;
}
.firmware-card__hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 16px;
  border-bottom: 1px solid #e2e5ec;
  font-weight: 600;
  font-size: 13px;
  color: #111827;
}
</style>
